<template>
    <div>
         <ThatsTable title="License Plate No." ref="table" :multipleSelection="true" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm"></ThatsTable>
        <DialogForm ref="moduleComponentForm" @success="refreshTable"></DialogForm>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './Table'
import {mdbTabs, mdbRow, mdbCol, mdbBtn,mdbSelect, mdbInput,mdbBadge} from 'mdbvue'
import { MessageBox } from 'element-ui';
import DateRangePicker from 'vue2-daterange-picker'
import { ThatsDatePicker, ThatsMultiSelect, ThatsInput} from '../../components/thats/Thats'
import ThatsMultiVueSelect from '../../components/thats/MultiVueSelect'
import { ValidationObserver,ValidationProvider } from "vee-validate";

import { Loading } from 'element-ui';
import DialogForm from './DialogForm.vue';

export default {
        components:{
        ThatsTable,
        mdbTabs,
        mdbBadge,
        DateRangePicker, mdbRow, mdbCol,
        ThatsDatePicker,
        mdbBtn,
        ThatsInput,
        ThatsMultiSelect,
        ValidationObserver,ValidationProvider,ThatsMultiVueSelect,
        mdbSelect,
        mdbInput,
        DialogForm
    },
    inject : ['categoryProvider'],
    provide(){
        return {
            btsApproverProvider : () => this.approverData
        }
    },
    data(){
        return {
            endpoint : 'warehouse-labels',
            approver : [],
            tableKey : 0,
            itemFormDialog : false,
            filterForm : {
                    searchTerm : [],
                    category : null,
                }
        }
    },


    created(){

        
    },

    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
    },
    methods: {

       ...mapActions('WarehouseLabelModule',['getRecord']),
       ...mapMutations('WarehouseLabelModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters','setFormData']),

        rowClick(row){
            const self = this;

            this.setFormStatusUpdate();
            this.setFormData(JSON.parse(JSON.stringify({...this.initialFormObject,...row})));
            this.$refs.moduleComponentForm.openDialog();
          
        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.moduleComponentForm.openDialog();
        },
        refreshTable(){
            this.tableKey++
            this.$refs.table.refreshTable()
           
        },

        clearFilterForm(){
            this.filterForm = JSON.parse(JSON.stringify(
                {
                    searchTerm : null,
                    category : null,
                }
            ))
        }

    },
    computed: {
        ...mapGetters('WarehouseLabelModule',['getLoading', 'columns','initialFormObject','labelTypes','selected']),
        
    },
}


</script>